export const BACKEND_ORIGIN = (
  import.meta.env.VITE_ATTENDVIP_API_ORIGIN ??
  import.meta.env.VITE_ATTENDVIP_PROXY_TARGET ??
  "https://api.attend.vip"
).replace(/\/$/, "")

// Console runs as its own worker, which same-origin-proxies /api + /auth +
// realtime to the backend (see src/server.ts) — rewriting Origin to a trusted
// value. So in the BROWSER we issue SAME-ORIGIN requests (no CORS, no
// dependency on this origin being in the backend's trustedOrigins). On the
// SERVER (SSR loaders / auth guard) we hit the backend directly.
export function backendUrl(path: string): string {
  if (/^https?:\/\//.test(path)) return path
  const p = path.startsWith("/") ? path : `/${path}`
  if (typeof window !== "undefined") return p
  return `${BACKEND_ORIGIN}${p}`
}

export function backendWsUrl(path: string): string {
  if (typeof window !== "undefined") {
    // Same-origin wss → the worker proxies the WS upgrade to the backend.
    const u = new URL(path.startsWith("/") ? path : `/${path}`, window.location.origin)
    u.protocol = u.protocol === "https:" ? "wss:" : "ws:"
    return u.toString()
  }
  const url = new URL(backendUrl(path))
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:"
  return url.toString()
}
